import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
const useSearchParamByName = t0 => {
  const $ = _c(3);
  const {
    name
  } = t0;
  const searchParamsFromUrl = useSearchParams();
  let t1;
  if ($[0] !== name || $[1] !== searchParamsFromUrl) {
    t1 = searchParamsFromUrl?.get(name) || null;
    $[0] = name;
    $[1] = searchParamsFromUrl;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useSearchParamByName;